const Donation = () => {
  return (
    <div>
      <h4 className="mb-1" style={{ color: "#023822" }}>Donation</h4>
      <p className="text-muted small">Coming soon.</p>
    </div>
  );
};

export default Donation;
